import { useSelector } from 'react-redux';

import { Box, Button } from '@zillow/constellation-10';

import type { RootState } from '../../../../../../store/types';
import RachelCSEvents from '@renter-hub/tracking/ClickStreamEvents';

interface PrimaryCTAProps {
  onClick: () => void;
  update: boolean;
}

const PrimaryCTA = ({ onClick, update }: PrimaryCTAProps) => {
  const user = useSelector((state: RootState) => state.user);

  const handleClick = () => {
    onClick();
    RachelCSEvents.emitClicksScheduleRentPaymentFromDashboardEvent({ user });
  };
  return (
    <Box css={{ marginTop: 'tighter', marginBottom: 'tighter' }}>
      <Button emphasis="filled" onClick={handleClick}>
        {update ? 'Update now' : 'Schedule rent payment now'}
      </Button>
    </Box>
  );
};

export default PrimaryCTA;
